import { render, staticRenderFns } from "./StaffVacationTrackerTable.vue?vue&type=template&id=030447a7"
import script from "./StaffVacationTrackerTable.vue?vue&type=script&lang=js"
export * from "./StaffVacationTrackerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports